const getTextInputAria = (required: boolean, error: boolean, id?: string) => {
    return {
        'aria-labelledby': `${id}-label`,
        'aria-required': required,
        'aria-describedby': `${id}-error ${id}-comment ${id}-hint`,
        'aria-invalid': error,
    };
};
export default getTextInputAria;
